export default __webpack_public_path__ + "static/media/1035.75ff00e6.png";